(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  const contactForm = document.getElementById('ContactForm')
  if (contactForm) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const fields = [...contactForm.querySelectorAll('[data-error-required], [data-error-invalid]')]

    const getError = (field) => {
      const value = field.value.trim()
      if (!value) return field.required ? field.dataset.errorRequired : ''
      const invalid =
        field.validity.typeMismatch ||
        field.validity.patternMismatch ||
        (field.type === 'email' && !emailPattern.test(value))
      return invalid ? field.dataset.errorInvalid : ''
    }

    const setError = (field, message) => {
      const error = document.getElementById(`${field.id}-error`)
      error.querySelector('[data-contact-error-message]').textContent = message
      error.hidden = !message
      if (message) {
        field.setAttribute('aria-invalid', 'true')
        field.setAttribute('aria-describedby', error.id)
      } else {
        field.removeAttribute('aria-invalid')
        field.removeAttribute('aria-describedby')
      }
    }

    // Capture phase: runs before Shopify's hCaptcha submit handler.
    contactForm.addEventListener(
      'submit',
      (event) => {
        const invalidFields = fields.filter((field) => {
          const message = getError(field)
          setError(field, message)
          return message
        })
        if (!invalidFields.length) return
        event.preventDefault()
        event.stopImmediatePropagation()
        invalidFields[0].focus()
      },
      true,
    )

    contactForm.addEventListener('input', (event) => {
      const field = event.target
      if (fields.includes(field) && field.getAttribute('aria-invalid') === 'true') setError(field, getError(field))
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if(location.hash != '') {
    const details = document.querySelector(location.hash);
    if(details) details.setAttribute('open', '');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sustainability-steps"] && !Shopify.designMode) return;
  try {
    
  const stepsSwiper = document.querySelector('[data-sustainability-steps-swiper]');
  if(stepsSwiper) {
    setTimeout(() => {
      new Swiper(stepsSwiper, {
        speed: 500,
        slidesPerView: 1,
        spaceBetween: 12,
      })
    }, 300);
  }

  } catch(e) { console.error(e); }
})();
})();
